import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, App, MenuController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { ServicioProvider } from '../providers/servicio/servicio';
import { LocationsProvider } from '../providers/locations/locations';
import { LocalLogout } from '../utils/local-logout';
import { CatalogsProvider } from '../providers/catalogs/catalogs';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  private readonly MODULO_ORDENES = 31;
  private readonly MODULO_REPORTES = 30;
  private readonly MODULO_PUNTO_VENTA_Y_CATALOGOS = 210;
  private readonly MODULO_ADMINISTRAR_CHECKIN = 211;
  private readonly MODULO_ADMIN = 212;
  private puedeVerOrdenes = false;
  private puedeVerReportes = false;
  private puedeAdministrarPuntoVenta = false;
  private puedeAdministrarCheckin = false;
  private puedeAdministrarUsuarios = false;
  @ViewChild(Nav) nav: Nav;

  componente = 0;
  text: string = '';
  rootPage: any = HomePage;
  pages: Array<{ title: string, ico: string, tiene_menu:boolean, show_hide: boolean, sub_menu: any, component: any, portada?: boolean, tipo?: string }>;
  conten = 0;

  array_sub_reportes: any =[]; //[{ titulo: "Resumen general" }, { titulo: "Comisiones" }];
  private localLogout = new LocalLogout();

  

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, 
    public servicio:ServicioProvider, public app: App, public menu: MenuController,
    private locations: LocationsProvider, private catalogs: CatalogsProvider) {
    // El navegador puede restaurar una ruta interna (por ejemplo #/catalogos)
    // antes de que WelcomePage cargue los reportes. El menú base debe existir
    // desde el arranque para que un F5 no lo deje vacío.
    this.pages = this.llenar_menu_lateral();
    if (this.servicio.hasActiveSession()) {
      const selectedLocation = this.servicio.elegir_locacion();
      if (selectedLocation) { this.locations.select(selectedLocation); }
      this.rootPage = 'WelcomePage';
      this.restoreSessionMenu();
    }
    
      platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
    });

  }


  menu_lateral(array) {

   //var array:any = this.servicio.ver_nombre_reportes();
   this.array_sub_reportes=[];
   for(let i =0;i<array.length;i++){
    this.array_sub_reportes.push({
      "id":array[i].idreporte,
      "titulo":array[i].reporte,
      "tipo":"reporte"
    });
   }
    
    this.actualizar_permisos_menu();

  }

  ver_y_ocultar(pos, page) {
   const array = page.sub_menu;
   this.conten = 3;
    if (page.tipo === 'usuario') {
      this.menu.close();
      this.app.getRootNav().setRoot('MiUsuarioPage');
      return;
    }
    if (array == -1) {
      this.componente = 3;
      this.menu.close();
      this.app.getRootNav().setRoot("WelcomePage");
      //this.nav.setRoot("OrdenesPage");
    }
    else {

      
      for (let i = 0; i < this.pages.length; i++) {
        if (i != pos) {
          this.pages[i].show_hide = false;
        }

      }

      if (this.pages[pos].show_hide == false) {
        this.pages[pos].show_hide = true;
      }
      else {
      
        this.pages[pos].show_hide = false;
      }

      
    }
  }

  ver_sub_menu(pos,idreporte, reporte, tipo, catalogo){

    for (let i = 0; i < this.pages.length; i++) {
      if (i != pos) {
        this.pages[i].show_hide = false;
      }

    }

    if (this.pages[pos].show_hide == false) {
      this.pages[pos].show_hide = true;
    }
    else {
    
      this.pages[pos].show_hide = false;
    }

    this.menu.close();

    if (tipo === 'catalogo') {
      this.app.getRootNav().setRoot("CatalogosPage", { catalogo: catalogo, titulo: reporte });
      return;
    }
    if (tipo === 'puntoVenta') {
      this.app.getRootNav().setRoot('MermasPage');
      return;
    }
    if (tipo === 'checkin') {
      this.app.getRootNav().setRoot(catalogo === 'reservaciones' ? 'CheckinReservacionesPage' : (catalogo === 'disclaimers' ? 'CheckinDisclaimersPage' : (catalogo === 'monitor' ? 'CheckinMonitorPage' : 'CheckinUsuariosPage')));
      return;
    }
    if (tipo === 'admin') {
      this.app.getRootNav().setRoot('AdminUsuariosPage');
      return;
    }
    this.servicio.save_name_reporte(reporte);
    this.servicio.save_ver_reporte(idreporte);
    this.app.getRootNav().setRoot("ReportesPage");
  }

  salir(){
    this.localLogout.execute(
      () => this.menu.close(),
      () => this.locations.clear(),
      () => {
        this.catalogs.clear();
        this.servicio.clear_session();
      },
      () => this.reiniciar_estado_menu(),
      () => this.nav.setRoot(HomePage)
    );
  }

  private reiniciar_estado_menu() {
    this.componente = 0;
    this.text = '';
    this.conten = 0;
    this.array_sub_reportes = [];
    this.puedeVerOrdenes = false;
    this.puedeVerReportes = false;
    this.puedeAdministrarPuntoVenta = false;
    this.puedeAdministrarCheckin = false;
    this.puedeAdministrarUsuarios = false;
    this.pages = this.llenar_menu_lateral();
  }

  private restoreSessionMenu(): void {
    const apiKey = this.servicio.ver_apikey_login();
    if (!apiKey) { return; }
    const request = 'apikey=' + apiKey + '&idmodulo=30';
    this.servicio.lista_reportes(request).then(data => {
      this.servicio.save_nombre_reportes(data !== 0 ? data : []);
      this.menu_lateral(data !== 0 ? data : []);
    });
  }

  llenar_menu_lateral() {

    const pages: any[] = [];
    if (this.puedeVerOrdenes) {
      pages.push({ title: 'Inicio/Órdenes', ico: '1', tiene_menu: false, show_hide: false, sub_menu: -1, component: HomePage });
    }
    if (this.puedeVerReportes) {
      pages.push({ title: 'Reportes', ico: '2', tiene_menu: true, show_hide: false, sub_menu: this.array_sub_reportes, component: HomePage });
    }

    if (this.puedeAdministrarPuntoVenta) {
      pages.push(
      { title: "Catálogos", ico: '3', tiene_menu:true, show_hide: false, component: HomePage, sub_menu: [
        { titulo: 'Usuarios', tipo: 'catalogo', catalogo: 'usuarios' },
        { titulo: 'Tipos de usuario', tipo: 'catalogo', catalogo: 'tiposUsuario' },
        { titulo: 'Tipos de producto', tipo: 'catalogo', catalogo: 'tiposProducto' },
        { titulo: 'Tipos de paquete', tipo: 'catalogo', catalogo: 'tiposPaquete' },
        { titulo: 'Productos', tipo: 'catalogo', catalogo: 'productos' },
        { titulo: 'Paquetes', tipo: 'catalogo', catalogo: 'paquetes' },
        { titulo: 'Programas', tipo: 'catalogo', catalogo: 'programas' },
        { titulo: 'Tipo de cambio', tipo: 'catalogo', catalogo: 'tiposCambio' },
        { titulo: 'Agencias y subagencias', tipo: 'catalogo', catalogo: 'agencias' },
        { titulo: 'Actividades', tipo: 'catalogo', catalogo: 'zonas' },
      ] },
      { title: 'Punto de venta', ico: '4', tiene_menu:true, show_hide: false, component: HomePage, sub_menu: [
        { titulo: 'Mermas', tipo: 'puntoVenta' }
      ] }
      );
    }

    if (this.puedeAdministrarCheckin) {
      pages.push(
      { title: 'Check-in', ico: '4', tiene_menu:true, show_hide: false, component: HomePage, sub_menu: [
        { titulo: 'Usuarios Check-in', tipo: 'checkin', catalogo: 'usuarios' },
        { titulo: 'Reservaciones', tipo: 'checkin', catalogo: 'reservaciones' },
        { titulo: 'Monitor', tipo: 'checkin', catalogo: 'monitor' },
        { titulo: 'Disclaimers', tipo: 'checkin', catalogo: 'disclaimers' }
      ] }
      );
    }

    if (this.puedeAdministrarUsuarios) {
      pages.push(
        { title: 'Admin', ico: '3', tiene_menu: true, show_hide: false, component: HomePage, sub_menu: [
          { titulo: 'Usuarios', tipo: 'admin', catalogo: 'usuarios' }
        ] }
      );
    }

    pages.push({ title: 'Usuario', ico: '3', tiene_menu: false, show_hide: false, sub_menu: null, component: HomePage, tipo: 'usuario' });

    return pages;

  }

  private actualizar_permisos_menu() {
    Promise.all([
      this.servicio.tiene_acceso_modulo(this.MODULO_ORDENES),
      this.servicio.tiene_acceso_modulo(this.MODULO_REPORTES),
      this.servicio.tiene_acceso_modulo(this.MODULO_PUNTO_VENTA_Y_CATALOGOS),
      this.servicio.tiene_acceso_modulo(this.MODULO_ADMINISTRAR_CHECKIN),
      this.servicio.tiene_acceso_modulo(this.MODULO_ADMIN),
    ]).then(permisos => {
      this.puedeVerOrdenes = permisos[0] === true;
      this.puedeVerReportes = permisos[1] === true;
      this.puedeAdministrarPuntoVenta = permisos[2] === true;
      this.puedeAdministrarCheckin = permisos[3] === true;
      this.puedeAdministrarUsuarios = permisos[4] === true;
      this.pages = this.llenar_menu_lateral();
    }).catch(() => {
      this.puedeVerOrdenes = false;
      this.puedeVerReportes = false;
      this.puedeAdministrarPuntoVenta = false;
      this.puedeAdministrarCheckin = false;
      this.puedeAdministrarUsuarios = false;
      this.pages = this.llenar_menu_lateral();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts